/**
 * Update :needRights-canManage, :needRights-canEdit, :needRights-canView
 * @param {String} htmlContent
 * @param {Object} browserAppAccountData
 * @returns {String} updated HTML string
 */
export function applyUserRights (htmlContent, browserAppAccountData) {
  // console.log('applyUserRights', browserAppAccountData)

  if (!htmlContent) return htmlContent
  if (!browserAppAccountData) return htmlContent
  if (!browserAppAccountData.data) return htmlContent

  const userRights = browserAppAccountData.data.userRights
  // console.log('userRights', userRights)

  const canManage = userRights?.includes('canManage')
  htmlContent = htmlContent.replaceAll(':needRights-canManage', canManage ? '' : 'is-hidden')

  const canEdit = userRights?.includes('canEdit')
  htmlContent = htmlContent.replaceAll(':needRights-canEdit', canEdit ? '' : 'is-hidden')

  const canView = userRights?.includes('canView')
  htmlContent = htmlContent.replaceAll(':needRights-canView', canView ? '' : 'is-hidden')

  return htmlContent
}
